import {Injectable} from '@angular/core';
import {HttpBackend, HttpClient, HttpParams, HttpHeaders} from '@angular/common/http';
import * as JWT from 'jwt-decode';
import {AUTH_USER_STORAGE, BASE_API_URL} from '../../config/app.config';
import {StorageFactory} from '../storage/storage.factory';
import {CannotGetAuthTokenEvent} from "@events/CannotGetAuthTokenEvent";

@Injectable()
export class AuthTokenService {

  private http: HttpClient;
  private refreshTokenMap: Map<string, Promise<any>> = new Map<string, Promise<any>>();

  constructor(private httpBackend: HttpBackend, private storage: StorageFactory, private cannotGetAuthTokenEvent: CannotGetAuthTokenEvent) {
    // This method is used to avoid the cyclic dependency error:
    // AuthInterceptor -> AuthService -> HttpClient -> AuthInterceptor
    // let authService = this.injector.get(AuthService);
    this.http = new HttpClient(httpBackend);
  }

  getAccessToken(): Promise<any> {
    return new Promise((resolve, reject) => {
      let strToken = this.storage.getItem(AUTH_USER_STORAGE);
      if (!strToken) {
        reject(new Error('Token does not exist'));
        return;
      }

      let token = JSON.parse(strToken);
      let authUser = JWT(strToken);

      if (this.isTokenExpired(authUser.exp)) {
        // refresh token
        this.refreshToken(token)
          .then(refreshTokenResults => {
            if (!refreshTokenResults || !refreshTokenResults.access_token || !refreshTokenResults.refresh_token) {
              reject(new Error('Invalid Token'));
            }

            // store the token with new values
            token.access_token = refreshTokenResults.access_token;
            token.refresh_token = refreshTokenResults.refresh_token;
            this.storeToken(token);
            resolve(token);
          })
          .catch(err => {
            console.log("Problem refreshing token: " + token.refresh_token);
            this.removeToken();
            this.cannotGetAuthTokenEvent.fire(token);
            reject(err);
          });
      } else {
        resolve(token);
      }
    });
  }

  refreshToken(token): Promise<any> {
    if (!token.refresh_token) {
      return Promise.reject(new Error('refreshToken parameter does not exist'));
    }

    if (this.refreshTokenMap.has(token.refresh_token)) {
      return this.refreshTokenMap.get(token.refresh_token);
    } else {
      let promise = this.callRefreshToken(token);
      this.refreshTokenMap.set(token.refresh_token, promise);
      return promise;
    }
  }

  callRefreshToken(token): Promise<any> {
    return  this.http.post(BASE_API_URL + 'auth/refresh', {}, {
      headers: new HttpHeaders().set('Authorization', [token.token_type, token.access_token].join(' ')),
      params: new HttpParams().set('refresh_token', token.refresh_token).set('redirect', 'web')
    }).toPromise();
  }

  storeToken(token) {
    this.storage.setItem(AUTH_USER_STORAGE, JSON.stringify(token));
  }

  removeToken() {
    this.storage.removeItem(AUTH_USER_STORAGE);
  }


  isTokenExpired(tokenExpireTime): boolean {
    const now = (Date.now() / 1000);
    return now > tokenExpireTime;

    // for testing token expires in 60 seconds
    // console.log("Token diff:" + (tokenExpireTime - now));
    // return (tokenExpireTime - now) < 3540;
  }
}



// WEBPACK FOOTER //
// D:/dclean-web-latest/task/cot-web/src/app/core/auth/auth-token.service.ts